<form *ngIf="!nuevo" class="example-form" [formGroup]="usersForm">
  <div>
    <div>
      <mat-form-field class="example-full-width" style="margin-top: 35px">
        <input
          [id]="id"
          matInput
          [placeholder]="crear ? 'Choose a part' : ''"
          [matAutocomplete]="auto"
          formControlName="userInput"
          #trigger="matAutocompleteTrigger"
        />
        <mat-hint align="start">
          Type the PN and select it, or create a new master if it's not listed
        </mat-hint>
      </mat-form-field>
      <!-- <span>Your choice is: {{usersForm.get('userInput').value | json}}</span> -->
      <mat-autocomplete
        id="special-autocomplete"
        (optionSelected)="OnHumanSelected($event.option)"
        #auto="matAutocomplete"
        [displayWith]="displayFn"
      >
        <mat-option *ngIf="loading" class="is-loading"
          ><mat-spinner diameter="50"></mat-spinner
        ></mat-option>
        <mat-option
          *ngIf="!loading && crear && hideNewMaster != 1"
          [value]="nuevoMaster"
        >
          <strong style="font-size: 20px">
            <i
              style="color: #28b463"
              class="fa fa-plus-circle"
              aria-hidden="true"
            ></i>
            &nbsp;
            {{
              showNonInventory
                ? "Non Inventory - New Master Item"
                : nuevoMaster.name
            }}
          </strong>
        </mat-option>
        <!-- <mat-option
          *ngIf="!loading && type === 'NoInventory'"
          [value]="quickMaster"
        >
          <strong style="font-size: 20px">
            <i
              style="color: black"
              class="fa fa-plus-circle"
              aria-hidden="true"
            ></i>
            &nbsp; {{ quickMaster.name }}
          </strong>
        </mat-option>-->
        <ng-container *ngIf="!loading">
          <mat-option
            *ngFor="let option of filteredClientes | async"
            [value]="option"
          >
            <span>{{ option.name }}</span>
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>
  </div>
</form>

<form *ngIf="nuevo" #f="ngForm">
  <div class="flex-container">
    <mat-form-field>
      <mat-label>Item</mat-label>
      <input
        type="text"
        matInput
        name="item"
        [(ngModel)]="masterItem.partNumber"
        (ngModelChange)="masterItem.partNumber = $event.toUpperCase()"
        (dblclick)="dosclicks()"
        required
      />
    </mat-form-field>

    <div class="w-100">
      <div>
        <span *ngIf="(getingMfgr || loading) && !loadingAI"
          >Mfgr<i class="fa fa-circle-o-notch fa-spin fa-fw"></i
        ></span>
        <div
          *ngIf="loadingAI"
          style="
            border-color: darkturquoise;
            border-style: ridge;
            text-align: center;
            padding: 5px;
            width: fit-content;
            background-color: aliceblue;
          "
        >
          <span style="vertical-align: bottom" class="material-icons">
            smart_toy
          </span>
          Working with AI <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </div>
      </div>

      <app-filter-object
        class="w-100"
        *ngIf="!savingMfgr"
        [options]="mgftList"
        [placeholder]="'Mfgr*'"
        [value]="masterItem.mfgr_id"
        [createOption]="'Add Mfgr'"
        (selectChange)="selectMfgr($event)"
      ></app-filter-object>
      <!-- <mat-form-field>
        <mat-label>Mfgr.</mat-label>
        <mat-select name="mfgr" [(ngModel)]="masterItem.mfgr_id"  required>
          <mat-option *ngFor="let manufacturer of mgftList" [value]="manufacturer.id" [value]="food.value">
            {{manufacturer.name}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    </div>
    <!-- <button
      [disabled]="loadingSyncMfgr"
      alt="MFGR sync from IQ"
      (click)="syncmfgr()"
      mat-raised-button
      mat-min-fab
      class="btn btn-primary btn-round btn-fab"
    >
      <i class="material-icons">sync</i>
    </button> -->

    <!-- <div class="col-md-4">
      <mat-form-field>
        <mat-label>Category</mat-label>
        <mat-select name="inventorycategory_id" [(ngModel)]="masterItem.inventorycategory_id" required>
          <mat-option *ngFor="let category of categories" [value]="category.id" [value]="food.value">
            {{category.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->

    <mat-form-field>
      <mat-label>Weight</mat-label>
      <input
        type="number"
        matInput
        name="weight"
        [(ngModel)]="masterItem.weight"
        [required]="weightRequired === 1"
      />
      <!--<input *ngIf="!weightRequired" type="number" matInput name="weight" [(ngModel)]="masterItem.weight">-->
    </mat-form-field>
  </div>
  <mat-checkbox name="bulk" [(ngModel)]="masterItem.bulk">Bulk</mat-checkbox>
  <hr class="divider" />
  <div class="row">
    <section class="col col-md-3">
      <label
        ><b
          >{{ categoria1() }} *<i
            *ngIf="loadingLevel1"
            class="fa fa-circle-o-notch fa-spin fa-fw"
          ></i></b
      ></label>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input
          type="search"
          matInput
          name="buscarLavel1"
          [(ngModel)]="searchLevel1"
          placeholder="Search"
        />
      </mat-form-field>
      <!-- <input
        type="search"
        class="form-control margen"
        name="buscarLavel1"
        [(ngModel)]="searchLevel1"
        placeholder="Search"
      /> -->
      <ul class="list-group scroll">
        <div *ngFor="let level1 of categories1">
          <li
            *ngIf="buscarLevel1(level1.name)"
            [ngClass]="{
              'list-group-item': masterItem.inventorycategory_id != level1.id,
              'selected-group-item':
                masterItem.inventorycategory_id == level1.id,
            }"
            (click)="selectLevel1(level1)"
          >
            {{ level1.name }}
          </li>
        </div>
      </ul>
      <form
        *ngIf="
          guard.permissions('create-mi-categories') ||
          this.identity.role == 'ADMINISTRATOR'
        "
      >
        <mat-form-field class="input-group mb-3">
          <mat-label>New Category</mat-label>
          <input
            id="new1"
            type="text"
            matInput
            name="new1"
            [(ngModel)]="nuevaC1"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <button
            class="btn-only-text"
            matSuffix
            (click)="newCategory(nuevaC1, 0, 1)"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4 || nuevaC1 === ''"
          >
            <app-icon
              *ngIf="!saveC1"
              name="fi-rr-disk"
              class="main-gray"
            ></app-icon>

            <!-- <i *ngIf="!saveC2" class="fa fa-floppy-o" aria-hidden="true"></i> -->
            <!-- <i *ngIf="!saveC1" class="fa fa-circle-o-notch fa-spin fa-fw"></i> -->
          </button>
        </mat-form-field>
        <!-- <div class="input-group mb-3" style="margin-top: 30px">
          <input
            id="new1"
            type="text"
            class="form-control"
            name="new1"
            [(ngModel)]="nuevaC1"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <div class="input-group-append">
            <button
              class="btn btn-link btn-default btn-just-icon"
              (click)="newCategory(nuevaC1, 0, 1)"
              [disabled]="
                saveC1 || saveC2 || saveC3 || saveC4 || nuevaC1 === ''
              "
            >
              <i *ngIf="!saveC1" class="fa fa-floppy-o" aria-hidden="true"></i>
              <i *ngIf="saveC1" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </button>
          </div>
        </div> -->
      </form>
    </section>

    <section class="col col-md-3">
      <label
        ><b
          >{{ categoria2() }}
          <i
            *ngIf="loadingLevel2"
            class="fa fa-circle-o-notch fa-spin fa-fw"
          ></i></b
      ></label>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input
          type="search"
          matInput
          name="buscarLavel2"
          [(ngModel)]="searchLevel2"
          placeholder="Search"
        />
      </mat-form-field>
      <!-- <input
        type="search"
        class="form-control margen"
        name="buscarLavel2"
        [(ngModel)]="searchLevel2"
        placeholder="Search"
      /> -->
      <ul class="list-group scroll">
        <div *ngFor="let level2 of categories2">
          <li
            *ngIf="buscarLevel2(level2.name)"
            [ngClass]="{
              'list-group-item': masterItem.inventorycategory_id2 !== level2.id,
              'selected-group-item':
                masterItem.inventorycategory_id2 === level2.id,
            }"
            (click)="selectLevel2(level2)"
          >
            {{ level2.name }}
          </li>
        </div>
      </ul>
      <form *ngIf="masterItem.inventorycategory_id !== null">
        <mat-form-field class="input-group mb-3">
          <mat-label>New Category</mat-label>
          <input
            id="new2"
            type="text"
            matInput
            name="new2"
            [(ngModel)]="nuevaC2"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <button
            class="btn-only-text"
            matSuffix
            (click)="newCategory(nuevaC2, masterItem.inventorycategory_id, 2)"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4 || nuevaC2 === ''"
          >
            <app-icon
              *ngIf="!saveC2"
              name="fi-rr-disk"
              class="main-gray"
            ></app-icon>

            <!-- <i *ngIf="!saveC2" class="fa fa-floppy-o" aria-hidden="true"></i> -->
            <i *ngIf="saveC2" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          </button>
        </mat-form-field>
        <!-- <div class="input-group mb-3" style="margin-top: 30px">
          <input
            id="new2"
            type="text"
            class="form-control"
            name="new2"
            [(ngModel)]="nuevaC2"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <div class="input-group-append">
            <button
              class="btn btn-link btn-default btn-just-icon"
              (click)="newCategory(nuevaC2, masterItem.inventorycategory_id, 2)"
              [disabled]="
                saveC1 || saveC2 || saveC3 || saveC4 || nuevaC2 === ''
              "
            >
              <i *ngIf="!saveC2" class="fa fa-floppy-o" aria-hidden="true"></i>
              <i *ngIf="saveC2" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </button>
          </div>
        </div> -->
      </form>
    </section>

    <section class="col col-md-3">
      <label
        ><b
          >{{ categoria3() }}
          <i
            *ngIf="loadingLevel3"
            class="fa fa-circle-o-notch fa-spin fa-fw"
          ></i></b
      ></label>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input
          type="search"
          matInput
          name="buscarLavel3"
          [(ngModel)]="searchLevel3"
          placeholder="Search"
        />
      </mat-form-field>
      <!-- <input
        type="search"
        class="form-control margen"
        name="buscarLavel3"
        [(ngModel)]="searchLevel3"
        placeholder="Search"
      /> -->
      <ul class="list-group scroll">
        <div *ngFor="let level3 of categories3">
          <li
            *ngIf="buscarLevel3(level3.name)"
            [ngClass]="{
              'list-group-item': masterItem.inventorycategory_id3 !== level3.id,
              'selected-group-item':
                masterItem.inventorycategory_id3 === level3.id,
            }"
            (click)="selectLevel3(level3)"
          >
            {{ level3.name }}
          </li>
        </div>
      </ul>
      <form *ngIf="masterItem.inventorycategory_id2 !== null">
        <mat-form-field class="input-group mb-3">
          <mat-label>New Category</mat-label>
          <input
            id="new3"
            type="text"
            matInput
            name="new3"
            [(ngModel)]="nuevaC3"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <button
            class="btn-only-text"
            matSuffix
            (click)="newCategory(nuevaC3, masterItem.inventorycategory_id2, 3)"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4 || nuevaC3 === ''"
          >
            <app-icon
              *ngIf="!saveC3"
              name="fi-rr-disk"
              class="main-gray"
            ></app-icon>
            <i *ngIf="saveC3" class="fa fa-circle-o-notch fa-spin fa-fw"></i>

            <!-- <i *ngIf="!saveC2" class="fa fa-floppy-o" aria-hidden="true"></i> -->
            <!-- <i *ngIf="!saveC1" class="fa fa-circle-o-notch fa-spin fa-fw"></i> -->
          </button>
        </mat-form-field>
        <!-- <div class="input-group mb-3" style="margin-top: 30px">
          <input
            type="text"
            class="form-control"
            name="new3"
            [(ngModel)]="nuevaC3"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <div class="input-group-append">
            <button
              class="btn btn-link btn-default btn-just-icon"
              (click)="
                newCategory(nuevaC3, masterItem.inventorycategory_id2, 3)
              "
              [disabled]="
                saveC1 || saveC2 || saveC3 || saveC4 || nuevaC3 === ''
              "
            >
              <i *ngIf="!saveC3" class="fa fa-floppy-o" aria-hidden="true"></i>
              <i *ngIf="saveC3" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </button>
          </div>
        </div> -->
      </form>
    </section>

    <section class="col col-md-3">
      <label
        ><b
          >{{ categoria4() }}
          <i
            *ngIf="loadingLevel4"
            class="fa fa-circle-o-notch fa-spin fa-fw"
          ></i></b
      ></label>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input
          type="search"
          matInput
          name="buscarLavel4"
          [(ngModel)]="searchLevel4"
          placeholder="Search"
        />
      </mat-form-field>
      <!-- <input
        type="search"
        class="form-control margen"
        name="buscarLavel4"
        [(ngModel)]="searchLevel4"
        placeholder="Search"
      /> -->
      <ul class="list-group scroll">
        <div *ngFor="let level4 of categories4">
          <li
            *ngIf="buscarLevel4(level4.name)"
            [ngClass]="{
              'list-group-item': masterItem.inventorycategory_id4 !== level4.id,
              'selected-group-item':
                masterItem.inventorycategory_id4 === level4.id,
            }"
            (click)="selectLevel4(level4)"
          >
            {{ level4.name }}
          </li>
        </div>
      </ul>
      <form *ngIf="masterItem.inventorycategory_id3 !== null">
        <mat-form-field class="input-group mb-3">
          <mat-label>New Category</mat-label>
          <input
            id="new4"
            type="text"
            matInput
            name="new4"
            [(ngModel)]="nuevaC4"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <button
            class="btn-only-text"
            matSuffix
            (click)="newCategory(nuevaC4, masterItem.inventorycategory_id3, 4)"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4 || nuevaC4 === ''"
          >
            <app-icon
              *ngIf="!saveC4"
              name="fi-rr-disk"
              class="main-gray"
            ></app-icon>
            <i *ngIf="saveC4" class="fa fa-circle-o-notch fa-spin fa-fw"></i>

            <!-- <i *ngIf="!saveC2" class="fa fa-floppy-o" aria-hidden="true"></i> -->
            <!-- <i *ngIf="!saveC1" class="fa fa-circle-o-notch fa-spin fa-fw"></i> -->
          </button>
        </mat-form-field>
        <!-- <div class="input-group mb-3" style="margin-top: 30px">
          <input
            type="text"
            class="form-control"
            name="new3"
            [(ngModel)]="nuevaC4"
            placeholder="New Category"
            [disabled]="saveC1 || saveC2 || saveC3 || saveC4"
          />
          <div class="input-group-append">
            <button
              class="btn btn-link btn-default btn-just-icon"
              (click)="
                newCategory(nuevaC4, masterItem.inventorycategory_id3, 4)
              "
              [disabled]="
                saveC1 || saveC2 || saveC3 || saveC4 || nuevaC4 === ''
              "
            >
              <i *ngIf="!saveC4" class="fa fa-floppy-o" aria-hidden="true"></i>
              <i *ngIf="saveC4" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </button>
          </div>
        </div> -->
      </form>
    </section>
  </div>

  <hr class="divider" />

  <div class="flex-container">
    <mat-form-field>
      <mat-label>Description</mat-label>
      <textarea
        matInput
        name="descripcion"
        rows="3"
        [(ngModel)]="masterItem.descripcion"
        required
      ></textarea>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Ext. Description</mat-label>
      <textarea
        matInput
        rows="3"
        name="ext_descripcion"
        [(ngModel)]="masterItem.ext_descripcion"
      ></textarea>
    </mat-form-field>
  </div>
  <hr class="divider" />

  <div class="d-flex justify-content-between">
    <app-button-primary
      (clickBtn)="back()"
      [outline]="true"
      iconLeftCustom="fi-rr-arrow-alt-to-left"
      label="Back"
      [disabled]="saving"
    >
    </app-button-primary>
    <app-button-primary
      (clickBtn)="save()"
      [primary]="true"
      iconLeftCustom="fi-rr-disk"
      label="Save"
      [disabled]="
        !f.valid ||
        saving ||
        !masterItem.inventorycategory_id ||
        !masterItem.mfgr_id ||
        isWeightInvalid()
      "
    >
    </app-button-primary>
  </div>
  <hr class="divider" />
</form>

<div
  id="nuevomfgrmodal"
  class="modal"
  tabindex="-1"
  [class.show]="showMfgrModal"
  [style.display]="showMfgrModal ? 'block' : 'none'"
  style="z-index: 1060; background-color: rgba(0, 0, 0, 0.5)"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2><b>Manufacturer</b></h2>
      </div>

      <div class="modal-body">
        <form #f2="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="bmd-label-floating">Name</label>
                <input
                  type="text"
                  class="form-control"
                  name="nombre"
                  [(ngModel)]="mfgr.name"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="bmd-label-floating">Full Name</label>
                <input
                  type="text"
                  class="form-control"
                  name="fullname"
                  [(ngModel)]="mfgr.fullname"
                />
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer" style="text-align: center">
        <button
          type="button"
          class="btn btn-danger btn-md"
          (click)="closeModal()"
        >
          Close
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-primary btn-md"
          (click)="saveMfgr()"
          [disabled]="!f2.valid || savingMfgr"
        >
          <i *ngIf="!savingMfgr" class="fa fa-floppy-o" aria-hidden="true"></i>
          <i
            *ngIf="savingMfgr"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          &nbsp; Save
        </button>
      </div>
    </div>
  </div>
</div>
